import Cart from "./cart";

export default class Order extends Cart {
  readonly orderSessionId: string;
  /** From checkout API `is_kyc_verified`; false when absent or falsy. */
  readonly isKycVerified: boolean;

  constructor(data: { [x: string]: any }) {
    super(data);
    this.orderSessionId = data.order_session_id;
    this.isKycVerified = Boolean(data.is_kyc_verified);
  }
}

export interface OrderItem {
  currency: string;
  order_id: string;
  product_id?: string;
  poster: string | null;
  order_item_id: string;
  order_item_status: string;
  order_status: string;
  quantity: number;
  redemption_ids: {
    id: string;
    is_redemed: boolean;
  }[];
  title: string;
  total_brought_price: number;
  total_brought_price_display: string;
  updated_at: number;
  store: string
}

export interface OrdersResponse {
  code: number;
  msg: string;
  response: OrderItem[];
  status: string;
}
